import React from "react";
import {connect} from "react-redux";
import {FlatList, SectionList, StyleSheet, Text, View} from "react-native";
import PostComment from "./PostComment";
import {withTranslation} from "react-i18next";
import {compose} from "redux";

class PostComments extends React.Component{
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        const styles=StyleSheet.create({
           title:{
               fontFamily:this.props.theme.fonts.text,
               fontSize:15,
               color:this.props.theme.colors.tertiary.black1.value
           }
        });

        // /!\ SW: comments could be null in the case of offline when built from feed item... (degraded experience)
        const comment = this.props.comment || [];

        return (
            <View style={{minHeight:120}}>
                <View><Text style={styles.title}>{this.props.t('Commentaires')} : </Text></View>
                <View>
                    {comment.length===0 && <Text>{this.props.t('Aucun Commentaire')}</Text>}
                    {comment.map((item,index)=><PostComment navigateToProfil={this.props.navigateToProfil} comment={item} key={index} />)}
                </View>
            </View>

        );
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme, auth : state.AuthReducer};
}

export default compose(connect(mapStateToProps),withTranslation())(PostComments);
